import React from 'react';
import {Button} from 'reactstrap';
import {get, isEqual} from 'lodash';
import {useHistory} from 'react-router-dom';
import {useRouteMatch} from 'react-router-dom';

import {useAuth} from 'contexts/AuthContext';
import {buildUrlParams} from 'utils/string';
import MuiIcon from 'components/Icons/MuiIcon';
import {useMembership} from 'contexts/MembershipContext';
import {SUBSCRIPTION_TYPE, SUBSCRIPTION_TYPE_LEVEL} from 'configs/membership';
import cleanDeep from 'clean-deep';

const LockedFeatureModalV2Actions = ({type, toggle, redirect}) => {
  const {account} = useAuth();
  const {push} = useHistory();
  const {
    isLegacyUser,
    subscriptionLevel,
    billingMethod,
    isTrial,
    isProcessingPayment,
  } = useMembership();

  const isoHistoryPath = useRouteMatch('/analytics/iso-history');
  const isoSurveyPath = useRouteMatch('/analytics/iso-survey');
  const realTimeAnalytics = useRouteMatch('/analytics/real-time-analytics');

  const checkAcc = (path) => get(account, path);
  const checkPlan = (plan) => isEqual(subscriptionLevel, plan);

  // plans
  const isManualMethod = billingMethod === 'manual';
  const isFree = checkPlan(SUBSCRIPTION_TYPE_LEVEL.free);
  const isEnterprise = checkPlan(SUBSCRIPTION_TYPE_LEVEL.enterprise);

  // version
  const isV1 = isLegacyUser && !isEnterprise && !isFree;

  // accounts or roles
  const accountRole = checkAcc('account_role');
  const currentPlanType = checkAcc(
    'company.subscription.subscription_plans_type'
  );
  const isAdminOrStaff = accountRole === 'admin' || accountRole === 'staff';

  const sourceType =
    (isoHistoryPath && 'history-paywall') ||
    (isoSurveyPath && 'iso-survey-mi-paywall') ||
    (realTimeAnalytics && 'real-time-analytics-paywall');

  if (type === 'market_intelligence') {
    let mainAction = null;

    if (isAdminOrStaff) {
      return (
        <div className="text-danger font-italic">
          <MuiIcon name="warning" /> Contact your SuperAdmin to get access to
          Market Intelligence.
        </div>
      );
    }

    if (isProcessingPayment) {
      mainAction = null;
    } else if (isV1 || isManualMethod) {
      mainAction = (
        <Button
          color="primary"
          className="mb-1"
          onClick={() => {
            toggle(type);
            push('/contact');
          }}
        >
          Contact Support
        </Button>
      );
    } else {
      mainAction = (
        <Button
          color="primary"
          className="mb-1"
          onClick={() => {
            toggle(type);
            push(
              buildUrlParams(
                '/membership/plans/checkout',
                cleanDeep({
                  market_intelligence: true,
                  redirect: isoHistoryPath
                    ? '/analytics/iso-history'
                    : '/analytics/certifications',
                  plan:
                    currentPlanType === 'free'
                      ? 'pay_as_you_go'
                      : currentPlanType,
                  source: sourceType,
                })
              )
            );
          }}
        >
          Get Instant Access
        </Button>
      );
    }

    return (
      <>
        {mainAction}
        <Button
          color={isAdminOrStaff ? 'primary' : 'link'}
          onClick={() => {
            toggle(type);
            push('/dashboard');
          }}
        >
          Go Back to Dashboard
        </Button>
      </>
    );
  }

  if (type === 'snapshot') {
    function handleClick() {
      toggle(type);
      if (isTrial) {
        // push upgrade to basic
        push(
          buildUrlParams('/membership/plans/checkout', {
            plan: SUBSCRIPTION_TYPE.basic,
            rerun: true,
            redirect,
          })
        );

        return;
      }

      // proceed normal upgrade to plans
      push(buildUrlParams('/membership/plans', {redirect, rerun: true}));
    }

    return (
      <Button color="primary" className="mr-2" onClick={() => handleClick()}>
        Subscribe now
      </Button>
    );
  }

  return <></>;
};

export default LockedFeatureModalV2Actions;
